import { useState } from 'react'
import TopCustomersList from '../../../../components/Lists/TopCustomersList'
import Select from '../../../../components/Inputs/Select'
import { DateTime } from 'luxon'

import {
  InfoContainer,
  FilterContainer,
  SubTitle
} from '../../styles'

export default function TopCustomers ({
  data: topCustomers,
  month = DateTime.now ().month,
  year = DateTime.now ().year
}) {
  const selectedDate = DateTime.local (year, month).setLocale ('pt-BR')
  const formattedDate = selectedDate.toFormat ('MMM yyyy')
  const [monthFilter, setMonthFilter] = useState ({
    label: formattedDate,
    value: formattedDate
  })

  if (!topCustomers || Object.keys (topCustomers).length === 0) {
    return null
  }

  return (
    <InfoContainer>
      <SubTitle>Top 10 clientes</SubTitle>
      <FilterContainer>
        <Select
          placeholder='Período...'
          value={monthFilter}
          options={Object.keys (topCustomers).map (month => ({
            label: month, value: month
          }))}
          onChange={(_, option) => setMonthFilter (option)}
          containerStyles={{width: 250}}
        />
      </FilterContainer>
      <TopCustomersList customers={topCustomers[monthFilter.value]}/>
    </InfoContainer>
  )
}
